var address = "Rua Cardeal Arcoverde nº 2365, Conjuntos 81 a 84, Sala 3, Bairro: Pinheiros, na cidade de São Paulo, estado de São Paulo, CEP: 05407-003";
var CNPJ = "30.247.128/0001-15";
var publicInfo = {
  address: address,
  CNPJ: CNPJ,
  "full-brand": "Consumidor Positivo Ltda.",
  "contact-email": "contato@consumidorpositivo.com.br"
};
export { CNPJ, address, publicInfo as default };